import { Box } from "@mui/material";
import { PropsPositionField } from "../propretiesComponents/PropsPositionField";
import { PropGroup } from "../propretiesComponents/PropGroup";
import { PropField } from "../propretiesComponents/PropField";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export const NodeProperties = ({
  element,
  onUpdate,
  onReset,
  disabled,
  errors,
  setElementSelection,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    setElementSelection([]);
  }, []);

  function handlePropChange(newValue, propKey, catKey) {
    var newProps = [];
    element[catKey].forEach((prop) => {
      newProps.push({
        ...prop,
        value: prop.key === propKey ? newValue : prop.value,
      });
    });
    onUpdate(newProps, catKey);
  }
  return (
    <Box className="flex flex-col gap-2">
      <PropGroup label="Base" borderWidth={0}>
        <PropField
          label="ID"
          value={element.id}
          onChange={onUpdate}
          propKey="id"
          type="display"
          disabled={disabled}
          errors={errors}
        />
        <PropField
          label="NAME"
          value={element.name}
          onChange={onUpdate}
          propKey="name"
          type="number"
          disabled={disabled}
          errors={errors}
        />
      </PropGroup>
      <PropGroup label={t("Location")} onReset={onReset}>
        <PropsPositionField
          value={element.position}
          propKey={"position"}
          onChange={onUpdate}
          disabled={disabled}
        />
      </PropGroup>
      <PropGroup label={t("Properties")}>
        {element.props &&
          element.props
            // "Existing Manhole" and "Lift station" are deactivated -> never
            // shown, stay false (lift stations are set by the optimization)
            .filter(
              (prop) =>
                prop.key !== "existing_manhole" && prop.key !== "lift_station"
            )
            .map((prop, index) => (
              <PropField
                key={prop.key}
                disabled={disabled}
                value={prop.value}
                label={prop.label}
                type={prop.type}
                propKey={prop.key}
                onChange={(value, key) => handlePropChange(value, key, "props")}
                errors={errors}
                unit={prop.unit}
              />
            ))}
      </PropGroup>
      {element.calc && (
        <PropGroup label={t("Calculated")}>
          {element.calc.map((prop, index) => (
            <PropField
              key={prop.key}
              disabled={disabled}
              value={prop.value}
              label={prop.label}
              type={prop.type}
              propKey={prop.key}
              onChange={(value, key) => handlePropChange(value, key, "calc")}
              errors={errors}
              unit={prop.unit}
            />
          ))}
        </PropGroup>
      )}
    </Box>
  );
};
